const KEY = 'ns_tutorial_done_pixi';

export interface TutorialStep {
  msg: string;
  hint: string;
}

export const TUT_STEPS: TutorialStep[] = [
  { msg: 'VISER avec la souris', hint: 'déplacez le curseur pour diriger le vaisseau' },
  { msg: 'TIRER — maintenez clic gauche', hint: 'tire en direction du curseur' },
  { msg: 'FREINER avec Espace', hint: 'coupe l’inertie' },
  { msg: 'BOOST avec Maj', hint: 'consomme du bouclier, augmente la vitesse max' },
  { msg: 'CHOC avec E', hint: 'renvoie les balles dans un rayon de 130 px' },
];

export function isTutorialDone(): boolean {
  return localStorage.getItem(KEY) === '1';
}
export function markTutorialDone(): void {
  localStorage.setItem(KEY, '1');
}
